import { render, staticRenderFns } from "./ebookDetail.vue?vue&type=template&id=40a5c9a2&scoped=true&"
import script from "./ebookDetail.vue?vue&type=script&lang=js&"
export * from "./ebookDetail.vue?vue&type=script&lang=js&"
import style0 from "./ebookDetail.vue?vue&type=style&index=0&id=40a5c9a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a5c9a2",
  null
  
)

export default component.exports